import { Dialog, DialogContent, DialogActions, CircularProgress } from "@mui/material";
import { FaTrashAlt } from "react-icons/fa";

import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiButton from "components/VuiButton";

const DeleteMaintenanceTaskDialog = ({ open, task, loading, error, onClose, onConfirm }) => {
  return (
    <Dialog
      open={open}
      maxWidth="xs"
      fullWidth
      onClose={(_, reason) => {
        if (loading) return;
        if (reason === "backdropClick") return;
        onClose?.();
      }}
    >
      <DialogContent sx={{ p: 2 }}>
        <VuiBox display="flex" flexDirection="column" alignItems="center" textAlign="center">
          <VuiBox
            width={40}
            height={40}
            borderRadius="50%"
            display="flex"
            alignItems="center"
            justifyContent="center"
            mb={2}
            sx={{
              background: "rgba(239,68,68,0.12)",
              border: "1px solid rgba(239,68,68,0.35)",
            }}
          >
            <FaTrashAlt size={14} color="#ef4444" />
          </VuiBox>

          <VuiTypography variant="h5" fontWeight="bold" mb={1}>
            Delete Task?
          </VuiTypography>

          <VuiTypography variant="caption" sx={{ lineHeight: 1.6 }}>
            Are you sure you want to delete this maintenance task? This action cannot be undone.
          </VuiTypography>

          {error && (
            <VuiTypography mt={2} variant="caption" color="error">
              {typeof error === "string" ? error : error?.message || "Failed to delete task"}
            </VuiTypography>
          )}
        </VuiBox>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3, justifyContent: "center", gap: 1.5 }}>
        <VuiButton variant="outlined" disabled={loading} onClick={onClose}>
          Cancel
        </VuiButton>

        <VuiButton variant="contained" color="error" disabled={loading} onClick={onConfirm}>
          {loading ? (
            <VuiBox display="flex" alignItems="center" gap={1}>
              <CircularProgress size={14} sx={{ color: "#fff" }} />
              Deleting...
            </VuiBox>
          ) : (
            "Delete Task"
          )}
        </VuiButton>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteMaintenanceTaskDialog;
